export default {
  fields: {
    name: "Name",
    duration: "Duration",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    confirmationEmail: "Customer email address",
    phone: "Phone",
    minimalAdvancedHours: "minimal hours in advance",
    lockReservationsForTodayAt: "lock reservations for today at",
    lockReservationsForTomorrowAt: "lock reservations for tomorrow at",
    minimalAdvancedDays: "minimal advanced days",
    slotStep: "slot step-15",
    lockReservationsForDisplayFrom: "lock reservations for display from",
    lockReservationsForDisplayTo: "lock reservations for display to",
    businessMobile: "business mobile",
  },

  c: {
    minutes: "Minutes",
    hours: "Hours",
    hours00: ":00",
    oclock: "o'clock",
    days: "Days",
    municipality: "City",
  },
  error: "Something wrong happened :(",
  login: {
    submit: "Login",
    username: "Username",
    password: "Password",
    register: "Register",
    errors: {
      credentials: "Username or password is wrong",
    },
  },
  register: {
    success: "Registration successful",
    errors: {
      rejected: "Registration failed",
    },
  },

  registerForm: {
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    back: "Back",
    submit: "Register",
  },
  lastMinute: {
    address: "Address",
    contact: "Your email",
    book: "Book appointment",
    error: "No appointments",
    booked: "Thank you! Appointment booked",
    customeurl : "Custom Redirect URL"
  },
  business: {
    dashboard: {
      title: "Overview",
      today: "Appointments at",
      todaytable: {
        date: "Date",
        time: "Time",
        duration: "Duration",
        customer: "Customer",
        offers: "Services",
      },
      employeestoday: {
        header: "",
      },
      customerstoday: {
        header: "",
      },
      calendarSync: {
        title: "Calendar synchronization",
        settings: "Open integration settings",
        unavailable: "Synchronization status is temporarily unavailable",
        pending: "Synchronization status is being verified",
        retry: "Please try again later",
        affectedProfiles: "Affected profiles ({count})",
        status: {
          NOT_CONNECTED: "No calendar connected",
          UNKNOWN: "Synchronization is being verified",
          OK: "Synchronization active",
          JOB_NOT_RUNNING: "Synchronization paused",
          TOKEN_INVALID: "Authorization is invalid",
          SELECTION_STALE: "Calendar selection no longer exists",
          NO_WRITABLE_CALENDAR: "No writable calendar",
          EMPTY_ACCOUNT: "Account has no calendars",
        },
      },
      table: {
        nodata: "Today no dates",
      },
    },
    tabs: {
      dashboard: "Overview",
      schedule: "Calendar",
      holidays: "Holiday",
      open: "Timetable",
      exceptions: "Exceptions",
      offers: "Offers",
      settings: "Settings",
      customers: "Customers",
    },
    sidebar: {
      dashboard: "Home",
      business: "Administration",
      customers: "Customers",
      appointments: "All appointments",
      logs: "History",
      newappointment: "New appointment",
      offers: "Offers",
      time: "Business Ours",
      integration: "External calendar",
      events: "Log",
    },
    holidays: {
      form: {
        name: "Holiday name",
        header: {
          new: "New holiday",
          edit: "Edit holiday",
        },
        from: {
          label: "From date",
          placeholder: "Date of holiday",
        },
        to: {
          label: "to",
          placeholder: "End of the holidays",
        },
        period: "Period",
        update: "Update",
        delete: "Delete",
        create: "Save",
        cancel: "Cancel",
      },
      table: {
        addholiday: {
          button: "Add holiday",
        },
        name: "Name",
        from: "from",
        to: "to",
        nodata: "No holiday",
      },
      import: {
        delete: {
          message: "Are you sure you want to delete all imported holidays?",
        },
      },
    },
    exceptions: {
      add: "Add exception",
      addhours: "Add period",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
    },
    offers: {
      add: {
        offer: "Add offer",
        duration: "Add duration",
      },
      drop: {
        duration: "Remove duration",
      },
      offer: {
        offer: "Offer",
        name: "Name of the offer",
        internal: "Internal name of the offer",
        pre: "Preparation time",
        duration: "Duration",
        post: "Follow-up time",
        active: "activated",
      },
      create: "Add offer",
      update: "Save offert",
      cancel: "Cancel",
      delete: "Delete offer",
    },
    settings: {
      tab: {
        business: "Business",
        lastMinute: "Last Minute",
        rules: "Rules",
        integrations: "Integrations",
        display: "Display",
      },
      notifications: {
        tab: "Notifications",
        event: "Event",
        customer: "Customer",
        employee: "Employee",
        business: "Business",
        save: "Save",
        saved: "Notifications saved",
        events: {
          CUSTOMER_REQUEST: "Customer: Request",
          CUSTOMER_CONFIRMATION: "Customer: Confirmation",
          CUSTOMER_CANCELLATION: "Customer: Cancellation",
          CUSTOMER_MESSAGE: "Customer: Message",
          USER_NEW_APPOINTMENT: "User: New appointment",
          USER_CANCELLATION: "User: Cancellation",
          SYSTEM_MISSING_CONFIRMATION: "System: missing confirmation",
        },
      },
      display: {
        hours: "Displayed hours",
        from: "from",
        to: "to",
      },
      colors: {
        external: "External appointments",
        unconfirmed: "Unconfirmed appointments",
        confirmed: "Confirmed appointments",
        holidays: "Holidays",
        update: "Color settings were updated successfully",
      },
      business: {
        name: "Company name",
        logo: "Company logo",
        changeLogo: "Change logo",
        address: "Company address",
        email: "Email of company",
        mobile: "Mobile of company",
        notifyEmail: "Notify by email",
        update: "Buisness settings were updated successfully",
      },
      lastMinute: {
        enable: "Enable Last Minute Page",
        page: "Last Minute Page",
        text: "Text",
        appointments: "Number of last minute appointments",
        submit: "Submit Page",
        submitted: "Last Minute Page updated",
        url: "URL for online booking (last minute)",
      },
      notify: "notify",
      email: {
        invalid: "The email address is invalid",
      },
      update: "Save",
      owner: {
        name: "Management Name",
        email: "Management Email",
        mobile: "Management Mobile",
        notify: "notify",
      },
      integration: {
        name: "Integrations",
        provider: "Provider",
        profile: "Email account",
        action: "Action",
        delete: "delete",
        addcalendar: "Integrate calendar",
        calendar: {
          title: "Sync calendar",
          current: "Current selection",
          target: "Target calendar",
          readonly: "(read-only)",
          none: "No calendars",
          stale: "Selection no longer exists",
          notActive: "Only the active profile syncs; selection disabled",
          preview: "Preview",
          execute: "Switch calendar",
          toMove: "randevu-bound bookings to move",
          alreadyOnTarget: "randevu-bound already on target",
          toDrop: "remote-bound entries to drop locally",
          manualReview: "Manual review needed",
          switched: "Calendar switched",
          confirm: "Switch calendar now?",
          failures: "Failed rows",
          statusActive: "Sync active",
          statusPaused: "Sync paused",
          statusInactive: "Not syncing",
          statusStale: "Selection no longer exists",
          selectionNoLongerExists: "Selection no longer exists",
          synchronizationPaused: "Synchronization paused",
        },
      },
      hours: {
        hoursadvance: "Booking at least hours in advance",
        daysahead: "Booking maximum days in advance",
        locktomorrow: "Block bookings for the next day at",
        locktoday: "Block bookings for today at",
        slotstep: "Start of appointment every x minute",
        update: "Booking hours successfully updated",
        error: "From hour has to be less then to hour",
      },
      booking: {
        url: "URL for online booking (standard)",
        copy: "Copy",
        goto: "Öffnen",
      },
    },
    newappt: {
      firstName: {
        label: "First name",
      },
      lastName: {
        label: "Last name",
      },
      email: {
        label: "Email",
      },
      phone: {
        label: "Phone",
      },
      comment: {
        label: "Comment",
      },
      appointment: {
        create: "Save appointment",
        cancel: "cancel",
        confirm: "save",
        delete: "reject",
      },
      confirmation: {
        title: "Send confirmation?",
        saved: "Appointment was saved",
        send: "Send",
        finish: "Done",
        queued: "Confirmation is being sent",
        failed: "Appointment saved, confirmation could not be sent",
      },
      errors: {
        taken: "This appointment is already taken",
        booking: "Appointment could not be saved",
      },
      offers: {
        nodata: "No offers",
      },
    },
    import: {
      cleanup: {
        header: "Delete imported holidays",
      },
      header: "Import holidays",
      submit: "import",
      delete: "Delete imported",
    },
    open: {
      title: "Business hours",
      edit: "Edit",
      save: "Save",
      delete: "Delete",
      cancel: "Cancel",
    },
    time: {
      tabs: {
        overview: "Overview",
      },
    },
    events: {
      loadmore: "Load more...",
    },
    integration: {
      tabs: {
        calendar: "calendar",
      },
    },
  },

  help: {
    business: {
      dashboard: {
        todaylist: {
          title: "Overview appointments",
          text: "Here you will find an overview of today’s appointments",
        },
      },
    },
  },

  exceptions: {
    title: "Exceptions",
  },
  customer: {
    table: {
      lastName: "Last name",
      firstName: "First name",
      email: "Email",
      phone: "Phone",
      appointments: "Appointments",
      nodata: "No customers",
    },
  },

  header: {
    menu: {
      logout: "logout",
    },
  },

  appointments: {
    label: "All appointments",
    update: "Save",
    notification: {
      updatesuccess: "Appointment were successfully updated",
      updateerror: "Appointment cant be updates, please try again",
    },
    table: {
      nodata: "No appointments",
      time: "Appointments",
      name: "Name",
      duration: "Duration",
      notes: "Notes",
      action: "Action",
      source: "Source",
      offers: "Offers",
      delete: "Delete",
      edit: "Edit",
      rndBound: "Booking",
      calBound: "Calendar",
      managedInCalendar: "Change in the connected calendar",
    },
    dialog: {
      delete: {
        title: "Delete appointment",
        message: "Are you sure you want to <b>delete</b> the appointment?",
        cancel: "Cancel",
        confirm: "Delete appointment",
        done: "Appointment has been deleted",
      },
    },
    noCalendar: {
      button: "No calendar connected",
      title: "No calendar connected",
      message: "Delete remaining entries from the external calendar in randevu?",
      confirm: "Yes",
      cancel: "No",
      done: "Entries deleted",
    },
  },

  admin: {
    test: {
      label: "Admin Test",
    },
    sidebar: {
      test: "Admin Test",
      dashboard: "Dashboard",
      api: "APIs",
      import: "Import",
      calendarSync: "Calendar sync",
    },
    calendarSync: {
      eyebrow: "Operations / Calendar sync",
      title: "Calendar synchronization",
      intro: "Connections, effective calendars and synchronized items across all accounts.",
      refresh: "Refresh",
      guide: {
        button: "Info",
        title: "Which action is right?",
        intro: "For “sync not working,” always start with Diagnose, then normally use Reconnect.",
        warning: "Do not use Disconnect as a repair step.",
        buttonColumn: "Button",
        useColumn: "Use it when",
        reconnectButton: "Reconnect",
        reconnectUse: "Sync should continue, but authorization/account/calendar is wrong or invalid. Press only when the customer is ready—the link expires after 15 minutes. Send the link, then press Check status, select a writable calendar, and Activate replacement",
        disconnectButton: "Disconnect",
        disconnectUse: "The customer no longer wants calendar sync and the integration should be permanently removed. Review the preview, then confirm the destructive cleanup",
        close: "Close",
      },
      accounts: "Accounts",
      configured: "with provider",
      attention: "Needs attention",
      attentionHint: "Configuration or metadata",
      activeUp: "Active UP",
      activeDown: "Active DOWN",
      allTime: "All time",
      search: "Search account, email or calendar",
      allProviders: "All providers",
      onlyAttention: "Attention only",
      updated: "Updated",
      id: "ID",
      account: "Account",
      providerLabel: "Provider",
      calendar: "Calendar",
      readOnly: "Read only",
      status: "Status",
      active: "Active",
      profiles: "Profiles active / total",
      empty: "No matching accounts found",
      upDefinition: "UP: Randevu bookings at the provider",
      downDefinition: "DOWN: provider items in Randevu",
      activeDefinition: "Active: future and not deleted",
      metadataPending: "Metadata pending",
      readiness: {
        notReady: "Not ready to synchronize",
        noCalendars: "No calendars found",
        emptyAccountContext: "{provider} account authorized · {count} calendars found",
        emptyAccountAction: "Create or share a calendar, or reconnect the correct account",
      },
      loadError: "Calendar sync overview could not be loaded",
      loading: "Loading calendar sync overview",
      unavailable: "Calendar sync data is currently unavailable",
      retry: "Try again",
      lastVerified: "Last verified",
      actions: "Actions",
      diagnose: "Diagnose",
      disconnect: "Disconnect",
      reconnect: "Reconnect",
      disconnectPreview: "Disconnect preview",
      confirmDisconnect: "Confirm disconnect",
      disconnectSucceeded: "Connection safely disconnected",
      reasonRequired: "Enter an auditable operator reason",
      createAuthorization: "Create authorization link",
      reconnectPending: "Customer authorization pending",
      customerMustAuthorize: "The customer must authorize provider access with the link",
      customerAuthorization: "Open authorization link",
      checkReconnect: "Check status",
      selectCalendar: "Select writable calendar",
      activateReplacement: "Activate replacement",
      confirmIdentityChange: "Verify the provider identity and calendar, then explicitly activate the replacement",
      replacementActivated: "Replacement activated; the old connection is retained until health is verified",
      operationFailed: "Operation failed",
      health: {
        OK: "Sync healthy",
        EMPTY_ACCOUNT: "Account has no calendars",
        TOKEN_INVALID: "Authorization invalid",
        NO_WRITABLE_CALENDAR: "No writable calendar",
        SELECTION_STALE: "Calendar selection stale",
        PROVIDER_UNAVAILABLE: "Provider unavailable",
        UNKNOWN_ERROR: "Status unknown",
        JOB_NOT_RUNNING: "Sync job not running",
      },
      provider: {
        NONE: "None",
        UNKNOWN: "Unknown",
      },
      states: {
        NONE: "Not connected",
        CONNECTED: "Connected",
        TOKEN_MISSING: "Token missing",
        DISABLED: "Disabled",
        READ_ONLY: "Read only",
      },
      calendarTypes: {
        NONE: "No calendar",
        MAIN: "Main calendar",
        SUBCALENDAR: "Subcalendar",
        UNKNOWN: "Unknown type",
      },
      warnings: {
        SYNC_DISABLED: "Sync disabled",
        TOKEN_MISSING: "Token missing",
        CALENDAR_READ_ONLY: "Calendar is read only",
        MULTIPLE_ACTIVE_PROFILES: "Multiple active profiles",
        UNKNOWN_PROVIDER: "Unknown provider",
        CALENDAR_METADATA_PENDING: "Calendar metadata pending",
        CALENDAR_SELECTION_STALE: "Selection is stale",
        HEALTH_SNAPSHOT_PENDING: "Health snapshot pending",
        JOB_NOT_RUNNING: "Sync job not running",
        EMPTY_ACCOUNT: "Account has no calendars",
        TOKEN_INVALID: "Authorization invalid",
        NO_WRITABLE_CALENDAR: "No writable calendar",
        SELECTION_STALE: "Selection is stale",
        PROVIDER_UNAVAILABLE: "Provider unavailable",
        UNKNOWN_ERROR: "Status unknown",
      },
    },
  },

  logs: {
    label: "History",
  },

  validation: {
    timeformat: "Format hh:mm",
    phoneformat: "Phone number is incomplete or invalid",
    timeoverlap: {
      from: "",
      to: "Invalid time period ",
      required: "Necessary entry",
    },
  },

  booking: {
        steps: [
            {
                title: "Personalien"
            },
            {
                title: "Termin"
            },
            {
                title: "Buchen"
            },
            {
                title: "Bestätigung"
            },
        ],
    profile: {
      header: "Personal data",
      step: "Personal data",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone",
      continue: "Next",
      comment: "Comment",
    },
    appointment: {
      book: "Book definitely",
      step: "Appointment",
      errors: {
        noslot: "No free timeslots available",
      },
      header: {
        offer: "Choose an appointment",
        book: "Book",
        date: "Date",
        duration: "Duration",
        service: "Service",
        time: "Time",
        summary: "Your appointment",
      },
    },
    finish: {
      step: "Done",
      thanks: "Thank you for booking",
    },
    confirm: {
      confirm: "Please confirm",
      link: "We have sent you a confirmation link to the following address:",
      finish: "Please click on the link in the email to confirm the booking.",
      progress1a: "Danke für Ihre Anfrage.",
      progress1b: "Der Termin wurde noch nicht gebucht.",
      progress2a: "Danke für die Bestätigung.",
      progress2b: "Ihr Termin ist reserviert.",
      thanks1: "Danke für die Bestätigung. Der Termin ist gebucht.",
      thanks2: "Sie erhalten eine Bestätigung per Email",
      step: "Confirmation",
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/i18n-en.js